import { createContext } from 'react';

export const SectionTitleContext = createContext<string | null>(null);

/**
 * surface is a field for the location a Segment tracking event occurs
 * surface is the lowercase title with only alphabetic characters
 * separated with hyphens
 */
export function getSurfaceName(title: string | null): string {
  if (!title) {
    return '';
  }

  const surface = title
    .toLowerCase()
    .replace(/[^A-Za-z\s_]/g, '')
    .replace(/ /g, '_');

  return surface;
}
